export default __webpack_public_path__ + "static/media/BackgroundPrice.07d0aba6.png";